import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/pj89hPCrQ1HwjLHbQqmfWd/controla_la_ansiedad_2.png';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-77">
      {/* Background decorative blobs */}
      <div className="absolute top-0 left-1/2 w-full -translate-x-1/2 h-full overflow-hidden -z-10 pointer-events-none" data-id="element-78">
        <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-sage-light rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob" data-id="element-79"></div>
        <div className="absolute top-[20%] right-[-10%] w-96 h-96 bg-lavender/30 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob" style={{
        animationDelay: '2s'
      }} data-id="element-80"></div>
        <div className="absolute bottom-[-20%] left-[20%] w-96 h-96 bg-cream rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob" style={{
        animationDelay: '4s'
      }} data-id="element-81"></div>
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-83">
          <span className="inline-block py-1 px-3 rounded-full bg-sage-light text-sage-dark text-sm font-medium mb-6 tracking-wide" data-id="element-84">
            Basado en neurociencia · Resultados en 2 minutos
          </span>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-heading font-bold text-brown leading-tight mb-6" data-id="element-85">
            Recupera el Control:{' '}
            <span className="text-sage-dark italic" data-id="element-86">
              Calma la Ansiedad en 2 Minutos
            </span>
          </h1>

          <p className="text-lg sm:text-xl text-brown-light mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-87">
            El sistema basado en neurociencia para resetear tu sistema nervioso,
            silenciar los pensamientos intrusivos y recuperar tu paz{' '}
            <strong className="text-brown font-semibold" data-id="element-88">
              sin medicamentos ni terapias costosas.
            </strong>
          </p>

          {/* Product image */}
          <motion.div className="mb-10 flex justify-center" initial={{
          opacity: 0,
          y: 30,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.3,
          ease: 'easeOut'
        }} data-id="element-89">
            <motion.img src={PRODUCT_IMAGE} alt="Controla la Ansiedad — Guía Digital y Audiolibro en tablet y teléfono" className="w-full max-w-lg rounded-2xl shadow-2xl shadow-brown/15" animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-90" />
          </motion.div>

          <div className="flex flex-col items-center gap-4" data-id="element-91">
            <CTAButton size="lg" className="w-full sm:w-auto" data-id="element-92">
              ¡Quiero Mi Protocolo de Calma Ahora! — $8.50
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6 mt-6 text-sm text-brown-light" data-id="element-93">
              <div className="flex items-center gap-1.5" data-id="element-94">
                <ShieldCheckIcon className="w-4 h-4 text-sage" data-id="element-95" />
                <span data-id="element-96">Compra 100% segura</span>
              </div>
              <div className="hidden sm:block w-1 h-1 rounded-full bg-sage/50" data-id="element-97"></div>
              <div className="flex items-center gap-1.5" data-id="element-98">
                <DownloadIcon className="w-4 h-4 text-sage" data-id="element-99" />
                <span data-id="element-100">Descarga inmediata</span>
              </div>
              <div className="hidden sm:block w-1 h-1 rounded-full bg-sage/50" data-id="element-101"></div>
              <div className="flex items-center gap-1.5" data-id="element-102">
                <SmartphoneIcon className="w-4 h-4 text-sage" data-id="element-103" />
                <span data-id="element-104">Android, iPhone y Computadora</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}